import { Component } from '@angular/core';
import { CstemapiService } from './cstemapi.service';
import { AuthService } from './auth.service';
import { Router, NavigationEnd } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
// declare ga as a function to set and sent the events
declare let ga: Function;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'CSTEM';
  userInfo;
  isCollapsed: boolean = true;

  constructor(public cstemapi: CstemapiService, public auth: AuthService, private myRoute: Router, private modalService: NgbModal) {
    this.userInfo = this.auth.getUserInfo();

    // console.log(this.userInfo)
    // this.myRoute.events.subscribe(event => {

    //   if (event instanceof NavigationEnd) {
    //     ga('set', 'page', event.urlAfterRedirects);
    //     ga('send', 'pageview');
    //   }

    // });
  }

  ngOnInit() { }

  redirect() {
    // console.log(this.myRoute.url);
    this.myRoute.navigate(["demo"]);
  }

  onActivate(event) {
    // console.log(event)
    window.scroll(0,0);
    // let scrollToTop = window.setInterval(() => {
    //   let pos = window.pageYOffset;
    //   if (pos > 0) {
    //     window.scrollTo(0, pos - 20); // how far to scroll on each step
    //   } else {
    //     window.clearInterval(scrollToTop);
    //   }
    // }, 16);
  }
}
